import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { FieldDiamond } from '../FieldDiamond';
import { ClipboardSheet } from './ClipboardSheet';
import type { CarouselSlide } from '../../data/vol5Carousel';
type CarouselCardProps = {
  slide: CarouselSlide;
  index: number;
  total: number;
};

/**
 * One 4:5 social card, drawn at 540×675 (export at 2× for 1080×1350).
 */
export function CarouselCard({
  slide,
  index,
  total
}: CarouselCardProps) {
  const isLast = index === total - 1;
  return <article aria-label={`Card ${index + 1} of ${total}`} className="relative flex h-[675px] w-[540px] flex-none snap-center flex-col overflow-hidden bg-navy px-9 pb-7 pt-8" data-id="element-43" data-mp="3dqcqxkyfod12">
      <FieldDiamond strokeWidth={2} className="pointer-events-none absolute left-1/2 top-[230px] h-[460px] w-[480px] -translate-x-1/2 text-white/[0.05]" data-id="element-44" data-mp="33rdponfzzjo3" />

      <div className="relative flex items-center justify-between" data-id="element-45" data-mp="wzd1jyw1lz8d">
        <span className="font-display text-[13px] tracking-[0.12em] text-gold" data-id="element-46" data-mp="11zqxwjoa7kqk">
          Vol. 5 · Shut Down the Inning
        </span>
        <span className="font-display text-[13px] tracking-[0.12em] text-white/50" data-id="element-47" data-mp="3vf0wt381ks4f">
          {index + 1}/{total}
        </span>
      </div>

      <h2 className="relative mt-3 font-display text-[38px] leading-[0.98] text-white" data-id="element-48" data-mp="dxhnpf83ebo0">
        {slide.lead} <span className="text-gold" data-id="element-49" data-mp="90hj78qw5gz0">{slide.accent}</span>
      </h2>

      <div className="relative flex flex-1 items-center justify-center pt-3" data-id="element-50" data-mp="3hezurkg1jend">
        <ClipboardSheet image={slide.image} label={slide.imageLabel} tilt={slide.tilt} data-id="element-51" data-mp="3hh2uwxawqo5t" />
      </div>

      <div className="relative mt-4 flex items-center justify-between gap-4" data-id="element-52" data-mp="3qg6es3hwf7ld">
        <p className="flex items-center gap-2.5 text-[15px] font-semibold text-white/85" data-id="element-53" data-mp="3mektbtratkzk">
          <span className="h-[3px] w-6 flex-none rounded-full bg-gold" data-id="element-54" data-mp="15pp4cfnllo2e" />
          {slide.caption}
        </p>
        {!isLast && <ArrowRightIcon className="h-5 w-5 flex-none text-gold" aria-hidden="true" data-id="element-55" data-mp="11n29s6zjlp1i" />}
      </div>
    </article>;
}